<template>
    <div class="a-line line" />
</template>

<script>
export default {
    name: 'ALine'
}
</script>

<style lang="scss">
@import "a-line";   
</style>